var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sandbox"},[_c('vue-headful',{attrs:{"title":"`ANEMONE - sandbox`"}}),_c('h1',[_vm._v("This is a sandbox page")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }